<template>
	<app-header-teleport>
		<app-title :title="`${businessName ? businessName : ''} Toppings`" />
	</app-header-teleport>

	<app-section v-if="!loading && !toppings.length" class="max-w-xl mx-auto">
		<div class="text-center p-10">
			<p class="text-lg font-semibold mb-6">
				Restorant <b>{{ businessName }}</b> nuk ka Toppings
			</p>
			<p>
				Ju lutem verifikoni te keni menune e axhornuar te Biznesit dhe te keni foto me kualitet te larte.
				Verifikoni permasat dhe dimensionin e fotove perpara se ti karikoni.
			</p>
			<div class="pt-6">
				<div class="dropdown inline-block relative w-full">
					<app-button class="btn btn-success w-full" icon="plus" @click="createTopping">
						Shto Toppings
					</app-button>
				</div>
			</div>
		</div>
	</app-section>

	<toppings-table
		v-if="toppings.length"
		:toppings="toppings"
		@create-topping="createTopping"
		@update-topping="updateTopping"
		@topping-moved="onToppingMoved"
		@create-topping-item="createToppingItem"
		@update-topping-item="updateToppingItem"
	/>
	<create-topping-modal
		:business-name="businessName"
		:show="isCreationModalVisible"
		@created="onToppingCreation"
		@close="isCreationModalVisible = false"
	/>
	<update-topping-modal
		v-if="isUpdateModalVisible"
		:business-name="businessName"
		:topping="selectedTopping"
		:show="isUpdateModalVisible"
		:canEdit="canEditToppings"
		@updated="onToppingUpdate"
		@close="isUpdateModalVisible = false"
	/>
	<topping-item-form-modal
		v-if="toppingItemModalVisible"
		:business-name="businessName"
		:topping-item="selectedToppingItem"
		:show="toppingItemModalVisible"
		:canEdit="canEditToppings"
		@submit="onToppingItemSubmit"
		@close="toppingItemModalVisible = false"
	/>
</template>

<script>
	import ToppingsTable from '../../components/sales/toppings/Table';
	import BusinessService from '../../services/sales/BusinessService';
	import CreateToppingModal from '../../components/sales/toppings/CreateToppingModal';
	import UtilityService from '../../services/UtilityService';
	import UpdateToppingModal from '@/components/sales/toppings/UpdateToppingModal';
	import ToppingItemFormModal from '@/components/sales/toppings/ToppingItemFormModal';
	import { mapGetters } from 'vuex';

	export default {
		name: 'ToppingsList',
		components: { ToppingItemFormModal, UpdateToppingModal, CreateToppingModal, ToppingsTable },
		props: {
			businessName: {
				type: String,
				required: true,
			},
		},
		data: () => ({
			isCreationModalVisible: false,
			isUpdateModalVisible: false,
			toppingItemModalVisible: false,
			loading: true,
			filters: {
				userSearch: '',
			},
			toppings: [],
			selectedTopping: {},
			selectedToppingItem: {},
		}),
		computed: {
			...mapGetters({
				user: 'user',
			}),
			businessId() {
				if (this.$route.params.id) {
					return this.$route.params.id;
				}
				console.log(this.user.restaurants[0]);
				return this.user.restaurants[0].restaurantID;
			},
			canEditToppings() {
				return BusinessService.canEditToppings();
			},
		},
		methods: {
			getToppings() {
				BusinessService.getToppings(this.businessId, this.filters)
					.then((toppings) => {
						this.toppings = toppings;
					})
					.finally(() => {
						this.loading = false;
						this.emitter.emit('isLoading', false);
					});
			},
			createTopping() {
				this.isCreationModalVisible = true;
			},
			updateTopping(topping) {
				this.selectedTopping = topping;
				this.isUpdateModalVisible = true;
			},
			onToppingCreation() {
				this.isCreationModalVisible = false;
				this.getToppings();
			},
			onToppingUpdate() {
				this.isUpdateModalVisible = false;
				this.getToppings();
			},
			createToppingItem(selectedTopping) {
				this.selectedToppingItem = { toppingTypeId: selectedTopping.id };
				this.toppingItemModalVisible = true;
			},
			updateToppingItem(toppingItem) {
				this.toppingItemModalVisible = true;
				this.selectedToppingItem = toppingItem;
			},
			onToppingItemSubmit() {
				this.toppingItemModalVisible = false;
				this.getToppings();
			},
			onToppingMoved({ oldIndex, newIndex }) {
				this.toppings = UtilityService.reOrderItems(this.toppings, oldIndex, newIndex);
				this.$notificationService.info('No API endpoint yet');
			},
		},
		mounted() {
			this.emitter.emit('isLoading', true);
			this.getToppings();
		},
	};
</script>
